<script>
	import Router from "svelte-spa-router";
	import routes from "./routes";
    import { alertinfo } from './store.js';
	import Alert from "./widgets/Alert.svelte";
	import Header from "./widgets/Header.svelte";
    import { onMount } from "svelte";
	let perem;
	function initWidth(){
		perem = document.body.clientWidth / 20;
	}
	onMount(() => {
		initWidth();
	});
	$: htmlWidth = `<style>html{font-size:${perem}px !important;}</style>`;
</script>
<svelte:head>{@html htmlWidth}</svelte:head>
<svelte:window on:resize={initWidth}/>

<Header />
<Router {routes} />

{#if $alertinfo}
	<Alert />
{/if}
